import services from './services.js';
import viewPhoto from 'src/common/js/viewPhoto';
import validate from 'validate';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';

//组件
import tree from 'Tree';
import areaSelect from 'area-select';
export default {
    mixins: [services],
    components: {
        'tree': tree,
        'area-select': areaSelect
    },
    props: {
        isReadOnly: {
            default: false
        },
        myIndex: {
            default: 1
        },
        value: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        hasDelFn: {
            default: true
        },
        isPerson: {
            default: false
        },
        isAdd: {
            default: true //新增
        },
        isOnlyHiInter: {
            default: false //判断该代理商是不是原来只代理hi幼教意向级别
        }
    },
    data() {
        return {
            isSetData: false,
            //代理信息
            agentInfo: this.refGetAgenInfo(),
            //intetPorjectList: MAP_LIST.INTENT_PROJECT, //合作项目
            //LevelTypes: this.$store.state.LevelTypes, //合作级别
            rules: {
                StartDate: [{
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            this.$notify({
                                title: '警告',
                                message: '请选择代理期限的开始时间！',
                                type: 'warning'
                            });
                            callback(new Error('请选择代理期限的开始时间！'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }],
                EndDate: [{
                    validator: (rule, value, callback) => {
                        let agentInfo = this.agentInfo;
                        if (value === '') {
                            this.$notify({
                                title: '警告',
                                message: '请选择代理期限的结束时间！',
                                type: 'warning'
                            });
                            callback(new Error('请选择代理期限的结束时间！'));
                        } else if (util.compareDate(util.time2str(agentInfo.StartDate), util.time2str(agentInfo.EndDate))) {
                            this.$notify({
                                title: '警告',
                                message: '代理期限结束时间要大于开始时间！',
                                type: 'warning'
                            });
                            callback(new Error('结束时间要大于开始时间！'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }]
            },
            isRequired: false, //用来判断是否必填
            areaList: [{}], //签约区域
            addAreaClass: 'addArea', //class定义
            showData: {}
        };
    },

    watch: {
        value: {
            deep: true,
            handler: function (val) {
                this.setValue();
            }
        },
    },
    methods: {
        refGetAgenInfo() {
            return cloneDeep({
                "ProjectType": '', //项目
                "PolicyType": 0, //政策
                "RebateLevel": 0, //级别
                "ContractNumber": "", //合同号
                "StartDate": "", //授权经销期限开始 
                "EndDate": "", //授权经销期限结束
                "DefendStartDate": "", //区域保护时间 
                "DefendEndDate": "", //区域保护时间 
                "ContractMoney": '', //合同预付款
                "AreaList": [], //签约区域
                "HNC_Drawing": [], //经销合作协议 
                "ContractMoney_Drawing": [], //合同款打款凭证
                "CooperateIntent": [] //合作意向书
            });
        },
        // 添加签约区域
        addArea() {
            this.areaList.push({})
        },
        // 删除签约区域
        delAreafn(item) {
            this.areaList.splice((item.index - 1), 1);
        },
        // 
        refGetAreaInfo() {
            return cloneDeep({
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null
            });
        },
        //切换合作级别
        changeAgentLevel(val) {

            if (this.isOnlyHiInter && val !== 1 && val !== '') {
                this.$alert('需要补充公司信息', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$emit('flag', true)
                    }
                });
                // this.$confirm('需要补充公司信息', '提示', {
                //     confirmButtonText: '确定',
                //     type: 'warning'
                // }).then(() => {
                //     this.$emit('flag', true)
                // })
            } else if (!this.isOnlyHiInter) {
                this.$emit('LevelVal', val)
            }

        },
        // 设置值
        setValue() {
            this.$nextTick(() => {
                this.showData = this.value
                let agentInfo = cloneDeep(this.value);
                this.agentInfo = $.extend({}, this.refGetAgenInfo(), util.filterAndSetData(this.refGetAgenInfo(), agentInfo));
                // 签约区域赋值
                if (agentInfo.AreaList) {
                    this.areaList = []

                    let len = agentInfo.AreaList.length
                    for (let i = 0; i < len; i++) {
                        this.areaList.push({
                            Provinces_Id: agentInfo.AreaList[i].ProvId,
                            City_Id: agentInfo.AreaList[i].CityId,
                            Area_Id: agentInfo.AreaList[i].AreaId
                        })

                    }
                }
            });

        },

        // 切换签约项目
        changeIntentProject(val) {
            if (this.isOnlyHiInter && val !== 2 && val !== '') {
                // this.$confirm('需要补充公司信息', '提示', {
                //     confirmButtonText: '确定',
                //     type: 'warning'
                // }).then(() => {
                //     this.$emit('flag', true)
                // })
                this.$alert('需要补充公司信息', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$emit('flag', true)
                    }
                });
            } else if (!this.isOnlyHiInter) {
                this.$emit('ProjectVal', val)
            }
            if (val == 4 && this.value == null) {
                this.agentInfo.ContractMoney = 0
            }


        },
        // 切换合作政策
        changePolicy(val) {

            if (val == 8 && this.agentInfo.ContractMoney == '') {
                // 智趣坞图书
                this.agentInfo.ContractMoney = 0
            } else {
                // 暂时只针对新增
                //this.agentInfo.ContractMoney = ''
            }
        },
        // 合作意向书删除
        delcoop_Drawing(i) {
            this.agentInfo.CooperateIntent.splice(i, 1);
        },
        // 经销合同协议
        delC_Drawing(list, i) {
            list.splice(i, 1);
        },

        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },


        areaSelectChange(i) {
            if (i == 0) return;
            let areaForm = this.$refs['areaForm' + (i + 1)][0].validate();
            if (areaForm) {
                this.areaList[i].Provinces_Id = areaForm.Provinces_Id
                this.areaList[i].City_Id = areaForm.City_Id
                this.areaList[i].Area_Id = areaForm.Area_Id
            }

        },
        validate() {
            let checkRules = [{
                name: "合作项目",
                value: this.agentInfo.ProjectType,
                required: true
            }, {
                name: "合作级别",
                value: this.agentInfo.RebateLevel,
                required: this.isHi,
                msg: '请选择合作级别'
            }, {
                name: "合作号",
                value: this.agentInfo.ContractNumber,
                required: true
                // !this.isIntent
            }, {
                name: "合作级别",
                value: this.agentInfo.RebateLevel,
                required: this.isHi,
                msg: '请选择合作级别'
            }, {
                name: "授权经销期限",
                value: this.agentInfo.StartDate,
                required: true,
                msg: '请选择授权经销期限'
            }, {
                name: "区域保护期限",
                value: this.agentInfo.DefendStartDate,
                required: !this.isIntent && this.agentInfo.ProjectType !== 4,
                msg: '请选择区域保护期限'
            }, {
                name: "合作意向书",
                value: this.agentInfo.CooperateIntent,
                required: this.isIntent,
                msg: '请上传合作意向书'
            }, {
                name: "合同预付款",
                value: this.agentInfo.ContractMoney,
                required: true,
            }, {
                name: "经销合同协议",
                value: this.agentInfo.HNC_Drawing,
                required: !this.isIntent,
                msg: '请上传经销合同协议'
            }, {
                name: "合同预付款打款凭证",
                value: this.agentInfo.ContractMoney_Drawing,
                required: this.agentInfo.ContractMoney > 0,
                msg: '请上传合同预付款打款凭证'
            }];

            var flag = util.checkForm({
                ele: this,
                rules: checkRules
            });

            this.agentInfo.AreaList = []
            if (flag) {
                for (let i = 0; i < this.areaList.length; i++) {
                    var areaForm = this.$refs['areaForm' + (i + 1)][0].validate();

                    this.agentInfo.AreaList.push({
                        "ProvId": areaForm.Provinces_Id,
                        "CityId": areaForm.City_Id,
                        "AreaId": areaForm.Area_Id
                    })

                }
            }
            if (!!areaForm && flag) {
                return this.agentInfo;
            } else {
                return false;
            }

        },
        resetFields() {
            //this.$refs.form.resetFields();
            this.agentInfo = this.refGetAgenInfo()
            this.areaList = [{}];
            for (let i = 0; i < this.areaList.length; i++) {
                this.$refs['areaForm' + (i + 1)][0].resetFields();
            }

        },
        deletefn(index) {
            this.$emit('delAgentfn', {
                index: index
            });
        },
    },
    created() {
        if (isCorrectVal(this.value)) {
            this.setValue();
            return;
        }
        this.agentInfo = this.refGetAgenInfo();

    },
    computed: {
        // 合作项目
        intetPorjectList() {
            if (this.isPerson) {
                // 个人
                this.agentInfo.ProjectType = 2

                return [{
                    id: 2,
                    name: "HI幼教"
                }]
            } else {

                if (this.value.ProjectType == undefined) {

                    this.agentInfo.ProjectType = ''
                }
                return [{
                    id: 1,
                    name: "美师优教"
                }, {
                    id: 2,
                    name: "HI幼教"
                }, {
                    id: 4,
                    name: "智趣坞"
                }]
            }
        },
        // 合作政策
        PoliceList() {
            if (this.agentInfo.ProjectType == 2) {
                // hi幼教
                if (!this.value.PolicyType) {
                    this.agentInfo.PolicyType = 64
                }

                return [{
                    key: 64,
                    value: "2018Q2招商政策"
                }, {
                    key: 512,
                    value: "2018Q3政策"
                }]
            } else if (this.agentInfo.ProjectType == 4) {
                // 智趣坞
                this.agentInfo.PolicyType = 8
                return [{
                    key: 8,
                    value: "N29"
                }]
            } else {
                this.agentInfo.PolicyType = 0
                return []
            }
        },
        // 合作级别
        LevelTypes() {
            if (this.isPerson) {
                // 个人
                this.agentInfo.RebateLevel = 1
                return [{
                    key: 1,
                    value: "意向商"
                }]
            } else {
                // 公司
                //this.agentInfo.RebateLevel = 0
                return [{
                        key: 1,
                        value: "意向商"
                    },
                    {
                        key: 2,
                        value: "C级商"
                    }, {
                        key: 4,
                        value: "B级商"
                    }, {
                        key: 8,
                        value: "A级商"
                    }
                ]
            }
        },
        // 意向级别显示且必填
        isIntent() {
            if (this.agentInfo.RebateLevel == 1 && this.agentInfo.ProjectType == 2) {
                // this.agentInfo.ContractNumber = '' //hi幼教意向级别没有合同号
                return true
            } else {
                return false
            }
        },
        // 判断市HI幼教
        isHi() {
            if (this.agentInfo.ProjectType == 2) {
                return true
            } else {
                this.agentInfo.RebateLevel = ''
                return false
            }
        },
        isHavePolicy() {
            if (this.agentInfo.PolicyType !== 0) {
                return true
            } else {
                this.agentInfo.PolicyType = 0
                return false
            }

        },
        sysSid() {
            return this.$store.state.sysSid;
        },
        sysSession() {
            return this.$store.state.sysSession;
        },
        // 经销商合作协议
        container() {
            return 'container-' + new Date().getTime();
        },
        browse_button() {
            return 'upload-btn-' + new Date().getTime();
        },
        // 合同款打款凭证
        ContractMoney_container() {
            return 'ContractMoney_upload-btn-' + new Date().getTime();
        },
        ContractMoney_button() {
            return 'ContractMoney-btn-' + new Date().getTime();
        },
        // 合作意向书
        adcoop_container() {
            return 'adcoop_container-' + new Date().getTime();
        },
        adcoop_button() {
            return 'adcoop_upload-btn-' + new Date().getTime();
        },

        getIndex() {
            return '合作信息-' + this.myIndex;
        },
        // 签约区域中的区不显示
        setComHide() {
            if (this.agentInfo.ProjectType == 4) {
                // 智趣坞
                return true;
            } else if (this.agentInfo.ProjectType == 2 && this.agentInfo.RebateLevel == 1) {
                // hi幼教意向商
                return true;
            }
            return false;
        },
        hasDelBtnShow() {
            if (this.isReadOnly || this.myIndex == 1) {
                // 第一个不显示删除按钮
                return false;
            }
            if (!this.hasDelFn) {
                return false;
            }
            return true;
        },
    },
    mounted() {
        this.$nextTick(() => {
            // 经销商合作协议
            util.initUploader(this, this.container, this.browse_button, (file) => {
                this.agentInfo.HNC_Drawing.push(file);
            });

            // 合作意向书
            util.initUploader(this, this.adcoop_container, this.adcoop_button, (file) => {

                this.agentInfo.CooperateIntent.push(file);
            });
            // 合同款打款凭证
            util.initUploader(this, this.ContractMoney_container, this.ContractMoney_button, (file) => {
                this.agentInfo.ContractMoney_Drawing.push(file);
            });


        });
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/agent-infonew/vm.js